(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hanger-rail"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('hanger-rail')) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  class HangerRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-item]'));
      this.nameEl = this.querySelector('[data-name]');
      this.subEl = this.querySelector('[data-sub]');
      this.modal = this.querySelector('[data-modal]');
      this.quick = this.dataset.quickview === 'true' && !!this.modal;
      this.active = -1;
      this.mi = 0;
      this.view = 'front';
      this._was = -1;
      this._pt = '';
      this._hoverTimer = null;
      this._centerTimer = null;

      var self = this;

      this.items.forEach(function (btn, i) {
        btn.addEventListener('pointerdown', function (e) {
          self._pt = e.pointerType;
          self._was = self.active === i ? i : -1;
        });
        btn.addEventListener('pointerenter', function (e) {
          if (e.pointerType === 'mouse') self.hoverActivate(i);
        });
        btn.addEventListener('focus', function () {
          self.activate(i);
          if (btn.matches(':focus-visible')) self.center(i);
        });
        btn.addEventListener('click', function (e) { self.onClick(e, i); });
        btn.addEventListener('keydown', function (e) { self.onKey(e, i); });
      });

      this.track.addEventListener('pointerleave', function (e) {
        if (e.pointerType === 'mouse') self.hoverClear();
      });

      this.querySelectorAll('[data-arrow]').forEach(function (a) {
        a.addEventListener('click', function () {
          var dir = parseInt(a.dataset.arrow, 10);
          self.track.scrollBy({ left: dir * self.track.clientWidth * 0.6, behavior: reduce.matches ? 'auto' : 'smooth' });
        });
      });

      this._onScroll = function () { self.updateArrows(); };
      this.track.addEventListener('scroll', this._onScroll, { passive: true });
      if (window.ResizeObserver) {
        this._ro = new ResizeObserver(function () { self.updateArrows(); });
        this._ro.observe(this.track);
      }
      this.updateArrows();

      if (this.quick) this.initModal();

      /* Theme editor support */
      this.addEventListener('shopify:block:select', function (e) {
        var i = self.items.findIndex(function (b) { return b.parentElement === e.target; });
        if (i > -1) { self.activate(i); self.center(i); }
      });
      this.addEventListener('shopify:block:deselect', function () { self.deactivate(); });
    }

    disconnectedCallback() {
      clearTimeout(this._hoverTimer);
      clearTimeout(this._centerTimer);
      if (this._ro) this._ro.disconnect();
      document.documentElement.classList.remove('hr-lock');
    }

    activate(i) {
      if (this.active === i) return;
      this.active = i;
      this.items.forEach(function (b, j) { b.parentElement.classList.toggle('is-active', j === i); });
      var d = this.items[i].dataset;
      if (this.nameEl) this.nameEl.textContent = d.title || '';
      if (this.subEl) this.subEl.textContent = d.subtitle || '';
      this.setAttribute('data-active', '');
    }

    deactivate() {
      this.active = -1;
      this.items.forEach(function (b) { b.parentElement.classList.remove('is-active'); });
      this.removeAttribute('data-active');
    }

    hoverActivate(i) {
      var self = this;
      clearTimeout(this._hoverTimer);
      this._hoverTimer = setTimeout(function () { self.activate(i); }, 70);
    }

    hoverClear() {
      var self = this;
      clearTimeout(this._hoverTimer);
      this._hoverTimer = setTimeout(function () {
        var el = document.activeElement;
        if (el && self.track.contains(el) && el.matches(':focus-visible')) return;
        self.deactivate();
      }, 140);
    }

    center(i) {
      var self = this;
      clearTimeout(this._centerTimer);
      this._centerTimer = setTimeout(function () {
        var li = self.items[i] && self.items[i].parentElement;
        if (!li) return;
        var t = self.track;
        var left = li.offsetLeft - (t.clientWidth - li.offsetWidth) / 2;
        t.scrollTo({ left: left, behavior: reduce.matches ? 'auto' : 'smooth' });
      }, reduce.matches ? 0 : 420);
    }

    updateArrows() {
      var t = this.track;
      var max = t.scrollWidth - t.clientWidth;
      var prev = this.querySelector('.hr__arrow--prev');
      var next = this.querySelector('.hr__arrow--next');
      if (prev) prev.disabled = t.scrollLeft <= 2;
      if (next) next.disabled = t.scrollLeft >= max - 2;
      if (max > 2) this.setAttribute('data-scrollable', ''); else this.removeAttribute('data-scrollable');
    }

    onClick(e, i) {
      var viaKeyboard = e.detail === 0;
      var shouldOpen = viaKeyboard ? this.active === i : this._was === i;
      this._was = -1;
      this.activate(i);
      if (shouldOpen) {
        if (this.quick) {
          this.openModal(i);
        } else if (this.items[i].dataset.link) {
          window.location.href = this.items[i].dataset.link;
        }
      } else if (this._pt && this._pt !== 'mouse') {
        this.center(i);
      }
    }

    onKey(e, i) {
      var n = this.items.length, to = -1;
      if (e.key === 'ArrowRight') to = Math.min(i + 1, n - 1);
      else if (e.key === 'ArrowLeft') to = Math.max(i - 1, 0);
      else if (e.key === 'Home') to = 0;
      else if (e.key === 'End') to = n - 1;
      else if (e.key === 'Escape') { this.deactivate(); return; }
      if (to > -1) { e.preventDefault(); this.items[to].focus(); }
    }

    /* ---------- Quick view ---------- */
    initModal() {
      var self = this, m = this.modal;
      this.mImg = m.querySelector('[data-m-img]');
      this.mTitle = m.querySelector('[data-m-title]');
      this.mSub = m.querySelector('[data-m-sub]');
      this.mToggle = m.querySelector('[data-m-toggle]');
      this.mLink = m.querySelector('[data-m-link]');
      this.mNavs = m.querySelectorAll('[data-step]');

      m.querySelector('[data-close]').addEventListener('click', function () { m.close(); });
      this.mNavs.forEach(function (b) {
        b.addEventListener('click', function () { self.step(parseInt(b.dataset.step, 10)); });
      });
      m.querySelectorAll('[data-view]').forEach(function (b) {
        b.addEventListener('click', function () { self.view = b.dataset.view; self.renderModal(); });
      });
      m.addEventListener('click', function (e) {
        if (!e.target.closest('button, a, img, .hr__m-info')) m.close();
      });
      m.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') self.step(1);
        else if (e.key === 'ArrowLeft') self.step(-1);
      });
      m.addEventListener('close', function () {
        document.documentElement.classList.remove('hr-lock');
        var b = self.items[self.mi];
        if (b) b.focus({ preventScroll: true });
      });
    }

    openModal(i) {
      this.mi = i;
      this.view = 'front';
      this.renderModal();
      if (!this.modal.open) this.modal.showModal();
      document.documentElement.classList.add('hr-lock');
    }

    step(dir) {
      var n = this.items.length;
      this.mi = (this.mi + dir + n) % n;
      this.view = 'front';
      this.renderModal();
      this.activate(this.mi);
    }

    renderModal() {
      var d = this.items[this.mi].dataset;
      var src = this.view === 'back' && d.back ? d.back : d.front;
      var img = this.mImg;
      if (src) { img.src = src; img.alt = d.title || ''; img.hidden = false; } else { img.hidden = true; }
      img.classList.remove('is-in');
      void img.offsetWidth;
      img.classList.add('is-in');
      this.mTitle.textContent = d.title || '';
      this.mSub.textContent = d.subtitle || '';
      this.mToggle.hidden = !d.back;
      var view = this.view;
      this.mToggle.querySelectorAll('[data-view]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.view === view ? 'true' : 'false');
      });
      this.mLink.hidden = !d.link;
      if (d.link) this.mLink.href = d.link;
      var many = this.items.length > 1;
      this.mNavs.forEach(function (b) { b.hidden = !many; });
    }
  }

  customElements.define('hanger-rail', HangerRail);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
